import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import useGolfFacilitiesDataSourceEnabled from '@lib/feature-flags/useGolfFacilitiesDataSourceEnabled'
import States from './states'

export const LIST_STATES_QUERY = gql`
query ListStates {
  listStates {
    state
    stateCode
  }
}
`

export default function StatesWithData(props) {
  const { ssrData, ...restProps } = props
  const golfFacilitiesDataSource = useGolfFacilitiesDataSourceEnabled()

  if (Array.isArray(ssrData)) {
    return <States {...restProps} states={ssrData} />
  }

  if (golfFacilitiesDataSource) {
    return <States {...restProps} states={[]} />
  }

  return (
    <Query query={LIST_STATES_QUERY} context={{ clientName: 'pga-algolia' }}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} />
        if (loading) return <LinearProgress color="secondary" />
        const response = data.listStates
        return (
          <States {...restProps} states={response} />
        )
      }}
    </Query>
  )
}

StatesWithData.propTypes = {
  ssrData: PropTypes.array,
}
